import { biometryApi } from '~/app/modules/biometry/utils/api.const';
import { WEB_ROUTES } from '~/app/shared/utils/web-config';
import { BIOMETRY_STATUS } from '~/app/modules/biometry/utils/biometry.consts';

export default async function({ app, $api, softRedirect }) {
  const isAllowEditBiometryProfile = app.$client.profile.clientBiometry.allowEditBiometryProfile;
  if (isAllowEditBiometryProfile) {
    return;
  }

  const {
    data: { status },
  } = await $api.dispatch(biometryApi.getBiometryStatus);

  if (status && status === BIOMETRY_STATUS.ACTIVE) {
    return;
  }

  softRedirect(app.localePath(WEB_ROUTES.PROFILE));
}
